import { createSlice } from '@reduxjs/toolkit';
import { ApplicationStatusMessageDetailStateType } from 'src/types/applicationStatusMessageDetail';

const initialState: ApplicationStatusMessageDetailStateType = {
    data: null,
    loading: false,
    error: false,
};
export const applicationStatusMessageDetailSlice = createSlice({
    name: 'applicationStatusMessageDetail',
    initialState,
    reducers: {
        getApplicationStatusMessageDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getApplicationStatusMessageDetailFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getApplicationStatusMessageDetailFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        createApplicationStatusMessageDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        createApplicationStatusMessageDetailFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        createApplicationStatusMessageDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        updateApplicationStatusMessageDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        updateApplicationStatusMessageDetailFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        updateApplicationStatusMessageDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        clearApplicationStatusMessageDetail: () => initialState,
    },
});

export const {
    getApplicationStatusMessageDetailFetch,
    getApplicationStatusMessageDetailFetchSuccess,
    getApplicationStatusMessageDetailFetchFailure,
    createApplicationStatusMessageDetailFetch,
    createApplicationStatusMessageDetailFetchSuccess,
    createApplicationStatusMessageDetailFetchFailure,
    updateApplicationStatusMessageDetailFetch,
    updateApplicationStatusMessageDetailFetchSuccess,
    updateApplicationStatusMessageDetailFetchFailure,
    clearApplicationStatusMessageDetail,
} = applicationStatusMessageDetailSlice.actions;

export default applicationStatusMessageDetailSlice.reducer;
